import styles from '@styles/home/heroBanner.module.scss';

const generateNewBannerHtml = () => `
  <section class="${styles.betterthatBanner}">    
    <div class="${styles.bannerContent}">
      <div class="${styles.contentWrapper}">
        <div class="${styles.textContent}">
          <h1><strong>Feed Australia, One Click at a Time</strong></h1>
          <p>Introducing the <strong>Food for Change Marketplace</strong>, powered by Betterthat Connect. Your one-stop shop for thousands of products at amazing prices. Every purchase you make helps us provide food relief to hungry Australians.</p>
          
          <p><strong>How it works:</strong> With each purchase, we receive a portion of the platform's commission, not from your purchase price. This means you're directly supporting our mission without spending a penny more.</p>
          <p><strong>Bonus: </strong>For every purchase, the platform donates up to 15% of their commission to a charity of your choice.</p>
          <p><strong>So, join us in making a difference. Shop now and help feed hungry Australians!</strong></p>
<!--          <a class="${styles.customBatn}" href="/products">Shop Now</a>-->
        </div>
        <div class="${styles.imageContent}">
          <img src="/img/Food-For-Change-137-scaled.jpg" alt="Betterthat illustration" />
        </div>
      </div>
    </div>
   
  </section>
  <div class="heading-section lula-bg text-center">Shop Now</div>
`;
export const replaceBanner = data => {
	if (!data || !data.raw_data) {
		return data;
	}

	try {
		const rawData = JSON.parse(data.raw_data);
		if (Array.isArray(rawData.blocks)) {
			const newBannerHtml = generateNewBannerHtml();

			rawData.blocks = rawData.blocks.map(block => {
				if (
					block.includes('class="shop-now-block"') &&
					block.includes('data-block-type="home_new"') &&
					block.includes('data-id="1"')
				) {
					return newBannerHtml;
				}

				if (block.includes('class="proud_title"')) {

					return block.replace(/Better That/g, 'Food for Change');

				}

				return block;
			});

			return {
				...data,
				raw_data: JSON.stringify(rawData),
			};
		}
	} catch (error) {
		console.error('Error parsing or modifying raw_data:', error);
	}

	return data;
};
